import { render, staticRenderFns } from "./ActiveUserCard.vue?vue&type=template&id=84fbb3b0"
import script from "./ActiveUserCard.vue?vue&type=script&lang=js"
export * from "./ActiveUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports